import React from 'react'
import './SkyBackdrop.scss'

/**
 * The view from a plane window, flying above the clouds into a sunny sky: a sky tinted with the
 * company colour, a warm sun glow ahead, and soft abstract cloud masses drifting past at different
 * speeds. Purely decorative; static for people who prefer reduced motion.
 */
const SkyBackdrop = () => (
  <div className="auth-shell__backdrop" aria-hidden="true">
    <div className="auth-sky" />
    <div className="auth-sun" />
    {[1, 2, 3, 4, 5, 6].map((n) => (
      <span key={`cloud-${n}`} className={`auth-cloud auth-cloud--${n}`} />
    ))}
    {[1, 2].map((n) => (
      <span key={`cirrus-${n}`} className={`auth-cirrus auth-cirrus--${n}`} />
    ))}
  </div>
)

export default SkyBackdrop
